import { render } from "./MyHomeAccessesView.vue?vue&type=template&id=1f8168f7&scoped=true"
import script from "./MyHomeAccessesView.vue?vue&type=script&lang=js"
export * from "./MyHomeAccessesView.vue?vue&type=script&lang=js"

import "./MyHomeAccessesView.vue?vue&type=style&index=0&id=1f8168f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8168f7"]])

export default __exports__